export function wSelectBlock () {
  $(window).on("load", () => {
    $(".double-select-block").css({transform: "translateY(0)", opacity: "1"});
  })
}


// WEBPACK FOOTER //
// ./assets/js/modules/wSelectBlock.js